<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Add Integration'" />
  }
</ng-template>

<ng-container
  *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="windowService.isDesktopRes ? 'right-side-scroll-enabled' : ''">
    <tidy-add-integration-form />
  </tidy-wrapper>
</ng-template>

@switch (windowService.isDesktopRes) {
  @case (true) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
  @case (false) {
    <app-scroll-wrapper [templateContent]="content" />
  }
}
